import { Table, TableColumnsType } from 'antd';
import _ from 'lodash';
import { FC, useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { useTranslation } from 'react-i18next';
import exportTitleTable from "../../../lib/exportTitleTable";
import { getCommonCodeLabel } from '../../../lib/store';
import { IPtStatsByGrade } from '../../../models/statistics.model';
import DownloadButton from '../../DownloadButton';
import Pagination from '../../Pagination';
import moment from 'moment';

interface IProps {
  rawData: IPtStatsByGrade[] | undefined;
  excelCampusCodes: string[];
  excelPeriod: string|undefined;
}

const PtStatsByGrade: FC<IProps> = ({ rawData, excelCampusCodes, excelPeriod }) => {
  // const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0006 = 학년
  // const SY0006 = commonCodes.find((item) => item.commonCode === 'SY0006')?.detailCode;
  const { t } = useTranslation();
  const { campusData } = useSelector((state: RootState) => state.campusData);
  
  const [data, setData] = useState<IPtStatsByGrade[]>([]);
  const [page, setPage] = useState(1);
  const [hasPhonics, setHasPhonics] = useState(false);
  const perPage = 30;

  useEffect(() => {
    if (rawData) {
      let _data: any = _.cloneDeep(rawData);
      
      if (rawData?.length) {
        _data.forEach((item: any, idx: number) => {
          item.rowIdx = idx;
          //Type1 Phonics 컬럼 관련 추가
          item.subjectInfo?.forEach((subitem: any) => {
            item[subitem.subjectName] = subitem.subjectScore;
            if(subitem.subjectName === 'Phonics') {
              setHasPhonics(true);
            }
          });
        });
      }

      setData(_data);
    }
  }, [rawData]);

  const getColumns = () => {
    const firstColumns: TableColumnsType<IPtStatsByGrade> = [
      {
        title: t('common.menu.campus'),
        dataIndex: 'campusKorName',
        key: 'campusKorName',
        align: 'center',
      },
      {
        title: t('statistics.placementTest.placeholder1'),
        dataIndex: 'examTypeName',
        key: 'examTypeName',
        align: 'center',
        className: 'ptStats-hl',
      },      
      {
        title: t('student.student.column3'),
        dataIndex: 'gradeCode',
        key: 'gradeCode',
        align: 'center',
        render: (value) => getCommonCodeLabel('SY0006', value, 'ko'),
      },
      {
        title: 'Overall',
        dataIndex: 'overall',
        key: 'overall',
        align: 'center',
        render: (value) => value === null ? '' : value,
      },
    ];
    const lastColumns: TableColumnsType<IPtStatsByGrade> = [
      {
        title: t('statistics.placementTest.column1'),
        dataIndex: 'averageTimeRequired',
        key: 'averageTimeRequired',
        align: 'center',
        render: (value) => value === null ? '' : value,
      },
      {
        title: t('statistics.placementTest.column2'),
        dataIndex: 'totalRequireCount',
        key: 'totalRequireCount',
        align: 'center',
      },
      {
        title: t('statistics.placementTest.column3'),
        dataIndex: 'participantCount',
        key: 'participantCount',
        align: 'center',
      },
    ];
    const middleColumns: TableColumnsType<IPtStatsByGrade> = [];

    if (rawData?.length) {
      // @ts-ignore
      rawData.at(0).subjectInfo?.forEach((item, idx) => {
        if(hasPhonics && idx === 1 && item.subjectName !== "Phonics") {
          middleColumns.push({
            title: "Phonics",
            dataIndex: "Phonics",
            key: "Phonics",
            align: 'center',
            className: 'ptStats-hl',
            render: (value) => {
              return value === undefined || value === null ? '' : value
            },
          });
        }

        middleColumns.push({
          title: item.subjectName,
          dataIndex: item.subjectName,
          key: item.subjectName,
          align: 'center',
          className: 'ptStats-hl',
          render: (value) => value === null ? '' : value,
        });
      });
    }

    return _.concat(firstColumns, middleColumns, lastColumns);
  };

  const onExportTable = () => {
    const currentDate = moment(new Date());

    let excelTitle = `${t('statistics.placementTest.title1')}(${t('student.student.column3')})`;
    let arrSubTitle = [];
    let campusNames = '';

    if(excelCampusCodes) {
      if(excelCampusCodes.length == 0) {
        campusNames = t('common.text.all');
      } else {
        excelCampusCodes.forEach((item) => {
          if(campusNames != '') {
            campusNames += ', '  
          }
          campusNames += campusData.find(campus => item == campus.campusCode)?.campusKorName;
        });
      }
    }
    
    arrSubTitle.push(t('common.excel.campus') + " : " + campusNames);
    if(excelPeriod !== '') {
      arrSubTitle.push(t('common.excel.period') + " : " + excelPeriod);
    }

    exportTitleTable(
      getColumns(),
      data,
      `${t('statistics.placementTest.title1')}(${t(
        'student.student.column3',
      )})_(${currentDate.format('YYYYMMDD')})`,
      `${t('student.student.column3')}`,
      [15, 12, 12, 15, 15, 15, 15, 15, 12, 10, 10],
      excelTitle, arrSubTitle
    );
  };

  return (
    <>
      <div className="comm-table__area">
        <Table
          columns={getColumns()}
          dataSource={data}
          pagination={{
            current: page,
            pageSize: perPage,
          }}
          rowClassName={(record: any) => record.campusCode === '0' ? 'tfoot' : ''}
          rowKey={'rowIdx'}
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
        <div className="common-paging center">
          <Pagination count={data.length} page={page} setPage={setPage} perPage={perPage} />
        </div>
      </div>
    </>
  );
};

export default PtStatsByGrade;
